export enum MembershipTypesEnum {
  QualifyingMember = "Qualifying Member",
  QualifyingLifeMember = "Qualifying and Life Member",
  LifeMember = "Life Member",
}

export default {};
